<template>
  <div class="tab2 module_item">
    <div class="clearfix">
      <span class="search_title">Index</span>
      <el-button class="search_reset" type="text" @click="resetChecked">Reset</el-button>
    </div>
    <div class="tree_search">
      <!-- <el-input placeholder="Please enter the indicator" v-model="filterText"></el-input> -->
      <div class="tree_container">
        <el-tree
          ref="tree"
          show-checkbox
          node-key="NodeCode"
          :props="defaultProps"
          empty-text="No data was found"
          :load="loadNode"
          :check-strictly="true"
          :check-on-click-node="false"
          lazy
          @check-change="handleCheckChange"
          @check="checkNode"
          :render-content="renderContent"
        ></el-tree> <!-- Revised on 2022-05-24 -->
      </div>
    </div>
  </div>
</template>

<script>
import { getIndictorsTree } from "common/js/http/v2Api";
import { get_industry_root_node, get_query_category_node } from "common/js/http/v3Api"; // <!-- Revised on 2022-05-24 -->
import { mapMutations, mapState } from "vuex";

const sourceMap = {
  "Agricultural product": "AGRICULTURAL_DATA",
  Custeel: "CUSTEEL_DATA",
  "Foodstuffs and Native Produce": "FOODSTUFF_DATA",
  "Information Technology Industry": "INFOTECH_DATA",
  "Nonferrous Metals Industry": "NONMETALS_DATA"
}; // <!-- Revised on 2022-05-24 -->

export default {
  data() {
    return {
      filterText: "",
      defaultProps: {
        children: "children",
        label: "NodeName",
        isLeaf: "leaf"
      } // <!-- Revised on 2022-05-24 -->
    };
  },

  computed: {
    ...mapState({
      treeChecked(state) {
        return state.IndustyChecked.treeChecked;
      },

      allKey(state) {
        return state.v2Permission.v2CurrentPermission;
      }
    })
  },

  methods: {
    resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    checkNode(data, status) {
      console.log("TCL: checkNode -> status", status);
      if(status.checkedNodes.length) {
        console.log("checkNode -> checkedNodes.length", status.checkedNodes.length)
        this.changeIndexShow(false);
      }
      // this.setTreeChecked(status.checkedNodes);
    },

    handleCheckChange(data, checked, indeterminate) {
      // const checkeddata = this.$refs.tree.getCheckedNodes();
      // console.log("TCL: loadNode -> checkeddata", checkeddata);
      // @check-change 事件会触发当前所有子节点的checkchange,会造成大量的函数调用
      // 改为check事件  只调用当前点击节点的check事件,触发一次

      /* 单选 fq */ // <!-- Revised on 2022-05-24 -->
      if (checked) {
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys([data.NodeCode])
          this.setTreeChecked(this.$refs.tree.getCheckedNodes())
        })
      }
    },

    async loadNode(node, resolve) {
      // <!-- Revised on 2022-05-24 -->
      if (node.level === 0) {
        const { data } = await get_industry_root_node({});
        if (data != null && data.length > 0) {
          let perResult = data.filter(item => {
            return item.NodeCode === 90000000 || item.NodeCode === 160000000
            // return item.NodeCode 
          })
          return setTimeout(() => {
            resolve(perResult);
            this.setParentNode();
          }, 700); //模拟 懒加载 避免接口时长过快,看不到加载效果  造成直接全选
        }
      } else {
        const { data } = await get_query_category_node({"NodeCode": node.data.NodeCode});
        if (data != null && data.length > 0) {
          data.forEach(item => {
            if (item["NoteCategory"] === 2) {
              item.leaf = true;
            }
          });
          let perResult = data
          return setTimeout(() => {
            resolve(perResult);
            this.setParentNode();
          }, 700); //模拟 懒加载 避免接口时长过快,看不到加载效果  造成直接全选
        }
      }
    },

    renderContent(h, { node, data, store }) {
      // <!-- Revised on 2022-05-24 -->
      if (data["NoteCategory"] != 2) {
        return (
          <span class="custom-tree-node">
            <span class="isParentCls" title={node.data.NodeName}>
              {node.data.NodeName}
            </span>
          </span>
        );
      } else {
        return (
          <span class="custom-tree-node">
            <span title={node.data.NodeName}>{node.data.NodeName}</span>
          </span>
        );
      }
    },

    //resove(node) 后 在下一个tick dom渲染完毕在获取dom元素
    setParentNode() {
      this.$nextTick(() => {
        const parenNode = document.getElementsByClassName("isParentCls");
        for (let item of parenNode) {
          // console.log("TCL: setParentNode -> item", item);

          const check = item.parentNode.previousElementSibling;
          if (check.getAttribute("class") == "el-checkbox") {
            check.style.display = "none";
          }
        }
      });
    },

    ...mapMutations(["setTreeChecked","changeIndexShow"])
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    treeChecked(newValue) {
      console.log("TCL: treeChecked -> newValue", newValue);
      //右侧删除时,手动去 设置新树的状态
      this.$refs.tree.setCheckedNodes(newValue);
    }
  }
};
</script>


<style scoped>
.search_title {
  float: left;
  font-size: 16px;
  color: #4e5671;
  line-height: 45px;
  font-weight: 600;
}
.search_reset {
  float: right;
  font-size: 16px;
  color: #0078ff !important;
  line-height: 45px;
  padding: 0px !important;
}
.tree_search >>> .el-input__inner {
  border-radius: 20px;
}
.tree_search >>> .el-input {
  margin-bottom: 20px;
}
.tree_search {
  height: 100%;
}
.tree_container {
  height: calc(100% - 180px);
  overflow: auto;
}
.tag_list {
  height: 200px;
  border: 1px solid #f3f4f5;
  padding: 10px;
  overflow: auto;
}
</style>